<template>
    <div class="relative">
        <Handle
            v-for="position in positions"
            :key="position"
            type="target"
            :id="position"
            :position="position"
            class="absolute opacity-0"
            :style="handleStyle(position)"
        />

        <div
            class="w-24 h-24 flex items-center justify-center bg-white shadow-lg border-2 hover:border-blue-500 transition-all duration-150 rounded-lg"
            :class="{'border-blue-500': props.isHover, 'border-white': !props.isHover}"
        >
            <BitrixLogo class="size-16 object-contain" />
        </div>
        <span :title="label" class="absolute text-xs">
            {{ props.label }}
        </span>
    </div>
</template>

<script setup>
import { Position, Handle } from '@vue-flow/core';
import { defineProps } from 'vue';
import BitrixLogo from '@/components/UI/svg/services/BitrixLogo.vue';

const props = defineProps({
    label: String,
    isHover: { type: Boolean, default: false },
});

const positions = [Position.Top, Position.Left, Position.Right, Position.Bottom];

const handleStyle = (position) => {
    const size = 0;
    const offset = -size / 2;

    switch (position) {
        case Position.Top: return { top: `${offset}px`, left: '50%', transform: 'translateX(-50%)' };
        case Position.Left: return { left: `${offset}px`, top: '50%', transform: 'translateY(-50%)' };
        case Position.Right: return { right: `${offset}px`, top: '50%', transform: 'translateY(-50%)' };
        case Position.Bottom: return { bottom: `${offset}px`, left: '50%', transform: 'translateX(-50%)' };
    }
};
</script>
